import React, { useEffect, useState } from 'react';
import styles from './AccountHealth.module.scss';
import { Col, Container, Row } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { healthColumns, healthData, healthStyles, orderContent, policyColumns, policyData, policyStyles } from '../complianceData';

export const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
        case 'good':
            return styles.statusGood;
        case 'at risk':
            return styles.statusAtRisk;
        case 'bad':
            return styles.statusBad;
        case 'pending':
            return styles.statusPending;
        case 'resolved':
            return styles.statusResolved;
        default:
            return '';
    }
};

const AccountHealth = () => {
    const [currentStatus, setCurrentStatus] = useState("Good");
    const [progressValue, setProgressValue] = useState(25);

    const messages = {
        "Good": <>Excellent! Your Account is in Good Health <div className={styles.emoji}>🥳</div></>,
        "At Risk": <>Warning! Your Account is at Risk of Suspension <div className={styles.emoji}>⚠️</div></>,
        "Suspend": <>Suspend! Your Account is Suspended <div className={styles.emoji}>❌</div></>,
    };

    // Function to simulate progress and status change
    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setProgressValue((prev) => {
    //             if (prev < 33) return 33; // Move to Good
    //             if (prev < 66) return 66; // Move to At Risk
    //             if (prev < 100) return 100; // Move to Suspend
    //             return 0; // Reset
    //         });
    //     }, 2000);
    //     return () => clearInterval(interval); // Cleanup interval
    // }, []);

    useEffect(() => {
        if (progressValue <= 33) setCurrentStatus("Good");
        if (progressValue > 33 && progressValue <= 66) setCurrentStatus("At Risk");
        if (progressValue > 66 && progressValue <= 100) setCurrentStatus("Suspend");
    }, [progressValue]);

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.mainHeading}>Account Health</h4>

            <Container fluid className={styles.headerText}>
                <p>
                    Maintaining a healthy account is crucial for your success on our platform. The Account
                    Health page provides an overview of your performance metrics, policy compliance and account
                    notifications. By monitoring these key areas, you can ensure your account remains in good
                    standing and continues to thrive.
                </p>
            </Container>

            <h5 className={styles.sectionHeading}>Health Score Indicator</h5>
            <Row className={styles.scoreIndicatorRow}>
                <Col>
                    <div className={styles.table}>
                        <DataTable
                            columns={healthColumns}
                            data={healthData}
                            highlightOnHover
                            customStyles={healthStyles}
                        />
                    </div>
                </Col>
                <Col className={styles.indicatorWrapper}>
                    <div className={styles.progressWrapper}>
                        {/* Progress Bar and Labels */}
                        <div className={styles.progressBar}>
                            <div
                                className={`${styles.progress} ${progressValue <= 33 ? styles.good : progressValue <= 66 ? styles.atRisk : styles.suspend}`}
                                style={{ width: `${progressValue}%` }}
                            ></div>
                            <div className={styles.statusPoints}>
                                <div className={`${styles.point} ${styles.goodPoint}`} style={{ left: "-2px" }}></div>
                                <div className={`${styles.point} ${styles.atRiskPoint}`} style={{ right: "50%" }}></div>
                                <div className={`${styles.point} ${styles.suspendPoint}`} style={{ right: "-2px" }}></div>
                            </div>
                        </div>
                        <div className={styles.legend}>
                            <span className={`${styles.label} ${progressValue <= 33 ? styles.active : ""}`}>Good</span>
                            <span className={`${styles.label} ${progressValue > 33 && progressValue <= 66 ? styles.active : ""}`}>At Risk</span>
                            <span className={`${styles.label} ${progressValue > 66 && progressValue <= 100 ? styles.active : ""}`}>Suspend</span>
                        </div>
                        {/* Dynamic Message */}
                        <p className={styles.message}>{messages[currentStatus]}</p>
                    </div>
                </Col>
            </Row>

            <h5 className={styles.sectionHeading}>Policy Compliance</h5>
            <Container fluid className={styles.mainTableContainer}>
                <div className={styles.dataTableContainer}>
                    <DataTable
                        title={"Following are the policies that you have violated, along with the date, status , and actions required or taken."}
                        columns={policyColumns}
                        data={policyData}
                        highlightOnHover
                        customStyles={policyStyles}
                    />
                </div>
            </Container>

            <h5 className={styles.sectionHeading}>Order Limit</h5>
            <Container fluid className={styles.listContainer}>
                <div className={styles.orderContent}>
                    <p>
                        Your account has an order limit value which restricts the maximum order volume you can
                        process. This limit ensures that you can manage and fulfill orders efficiently without
                        compromising on quality or delivery times.
                    </p>
                    <ul>
                        {orderContent.map((item, index) => (
                            <li key={index}>
                                {item.heading}: <span>{item.content}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </Container>
        </div>
    )
}

export default AccountHealth;